// extracted by mini-css-extract-plugin
export var typingIndicator = "_nt-0";